import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Message} from "../utilites";
import {
  migrateClients,
  migrateDeals,
  openAlertMigrateSuccess,
  openModalMigration,
  setIndexClients,
  setIndexDeals
} from "../../redux/actions/mcsIntegrationAction";
import LoaderLinear from "../utilites/Loader/Loader";
import CrossIcon from "../../assets/icons/cross.svg";
import ReactModal from "react-modal";
import {permissionsAccess} from "../../helpers/common";
import {mcsIntegrationService} from "../../services/mcs-migrate-servise";
import {messages} from "../../helpers/messages";
import BasicAlert from "../utilites/Alert/Alert";

export const McsIntegration = () => {
  const {
    integratedClientCount,
    integratedDealCount,
    errorMessage,
    isLoadingClient,
    isLoadingDeal,
    isLoadingIndex,
    isOpen,
    isAlert,
  } = useSelector(({mcsIntegration}) => mcsIntegration)
  const dispatch = useDispatch();
  const [state, setState] = useState(
    {
      modal: '',
      allClients: '',
      allDeals: '',
      loading: false,
      firstLoadClients: true,
      firstLoadDeals: true,
    }
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await mcsIntegrationService.getClientsCount();
        const integratedClientCount = response.data.integratedClientCount;
        if (state.firstLoadClients) {
          setState(prev => ({
            ...prev,
            allClients: integratedClientCount,
            firstLoadClients: false
          }));
        } else {
          if (integratedClientCount !== state.allClients && (!isLoadingClient || !isLoadingDeal)) {
            setState(prev => ({
              ...prev,
              allClients: integratedClientCount,
              loading: true
            }));
          } else {
            setState(prev => ({
              ...prev,
              loading: false
            }));
          }
        }
      } catch (error) {
        if (error.response) {
          let errorData = error.response.data;
          let commonError = messages[0];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          window.scrollTo(0, 0);
          throw commonError;
        }
      }
    };

    state.firstLoadClients ? fetchData() : setTimeout(() => {
      fetchData();
    }, 7000)
  }, [state.allClients]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await mcsIntegrationService.getDealsCount();
        const integratedDealCount = response.data.integratedDealCount;
        if (state.firstLoadDeals) {
          setState(prev => ({
            ...prev,
            allDeals: integratedDealCount,
            firstLoadDeals: false
          }));
        } else {
          if (integratedDealCount !== state.allDeals && (!isLoadingClient || !isLoadingDeal)) {
            setState(prev => ({
              ...prev,
              allDeals: integratedDealCount,
              loading: true
            }));
          } else {
            setState(prev => ({
              ...prev,
              loading: false
            }));
          }
        }
      } catch (error) {
        if (error.response) {
          let errorData = error.response.data;
          let commonError = messages[0];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          window.scrollTo(0, 0);
          throw commonError;
        }
      }
    };

    state.firstLoadDeals ? fetchData() : setTimeout(() => {
      fetchData();
    }, 7000)
  }, [state.allDeals]);

  const openModal = (name) => {
    setState(prev => ({
      ...prev,
      modal: name
    }))
    dispatch(openModalMigration(true))
  }

  const closeModal = () => {
    setState(prev => ({
      ...prev,
      modal: ''
    }))
    dispatch(openModalMigration(false))
  }

  const onCloseAlert = () => {
    dispatch(openAlertMigrateSuccess())
  }

  const summitIntegrationClients = () => {
    dispatch(migrateClients())
  }

  const summitIntegrationDeals = () => {
    dispatch(migrateDeals())
  }

  const summitIndexClients = () => {
    dispatch(setIndexClients())
  }

  const summitIndexDeals = () => {
    dispatch(setIndexDeals())
  }

  const modalContent = {
    'clients': {
      'title': 'Импортировать клиентов',
      'submit': summitIntegrationClients
    },
    'deals': {
      'title': 'Импортировать договора',
      'submit': summitIntegrationDeals,
    },
    'indexClients': {
      'title': 'Проиндексировать клиентов',
      'submit': summitIndexClients
    },
    'indexDeals': {
      'title': 'Проиндексировать договора',
      'submit': summitIndexDeals,
    },
  }

  const disabled = state.loading || isLoadingClient || isLoadingDeal || isLoadingIndex

  return (

    <div className="content-inner-data-container">
      {disabled && <Message type={"info"} text={`База данных ${(isLoadingClient || isLoadingDeal) ? 'импортируется' : 'индексируется'}, пожалуйста подождите!`}/>}
      {errorMessage && <Message type="error" text={errorMessage}/>}
      <table className="updatingDirectories-container">
        <tbody>
        <tr>
          <td>
            <button className={(disabled || !permissionsAccess('mcs.migration')) ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                    disabled={disabled || !permissionsAccess('mcs.migration')}
                    onClick={() => openModal('clients')}>Импорт клиентов
            </button>
          </td>
          <td>
            <button className={(disabled || !permissionsAccess('mcs.migration')) ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                    disabled={disabled || !permissionsAccess('mcs.migration')}
                    onClick={() => openModal('deals')}>Импорт договоров
            </button>
          </td>
          <td>
            <button className={(disabled || !permissionsAccess('mcs.migration')) ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                    disabled={disabled || !permissionsAccess('mcs.migration')}
                    onClick={() => openModal('indexClients')}>Проиндексировать клиентов
            </button>
          </td>
          <td>
            <button className={(disabled || !permissionsAccess('mcs.migration')) ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                    disabled={disabled || !permissionsAccess('mcs.migration')}
                    onClick={() => openModal('indexDeals')}>Проиндексировать договора
            </button>
          </td>
        </tr>
        <tr>
          <td className="updatingDirectories-item">
            {integratedClientCount !== null && <span>Импортировано новых клиентов: {integratedClientCount}</span>}
          </td>
          <td className="updatingDirectories-item">
            {integratedDealCount !== null && <span>Импортировано новых договоров: {integratedDealCount}</span>}
          </td>
        </tr>
        <tr>
          {!!state.allClients && <td><span>Общее количество клиентов: {state.allClients}</span></td>}
          {!!state.allDeals && <td><span>Общее количество договоров: {state.allDeals}</span></td>}
        </tr>

        </tbody>
      </table>
      <ReactModal
        className="modal-container"
        overlayClassName="modal-overlay"
        isOpen={isOpen}>
        <LoaderLinear isLoading={isLoadingClient || isLoadingDeal || isLoadingIndex}/>
        <div className="modal-header indexModal-containerModal">
          <h2>{modalContent[state.modal]?.title}</h2>
          <button
            className="button-icontrigger modal-closetrigger"
            onClick={closeModal}>
                    <span className="icon">
                         <CrossIcon/>
                    </span>
          </button>
        </div>
        <div className="modal-footer">
          <button className={disabled ? "button-light" : "button"}
                  onClick={modalContent[state.modal]?.submit}
                  disabled={disabled}>Да
          </button>
          <button className="button-light" onClick={closeModal}>
            Нет
          </button>
        </div>
      </ReactModal>
      <BasicAlert onClose={onCloseAlert}
                  message="Действие выполнено успешно"
                  isOpen={isAlert}
      />
    </div>
  )
}
